import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
const QRCodeGenerator = ({ value }) => {
  return (
    <div className="w-full flex justify-center">
      <QRCodeSVG size={115} value={value} />
    </div>
  );
};

export default QRCodeGenerator;
